
export function pythonDayNumber(javascriptDayNumber) {
    let newDayNumber = (javascriptDayNumber - 1) % 7
    while(newDayNumber < 0) {
        newDayNumber+=7
    }
    return newDayNumber
}